export enum PostgreDataType {
  VARCHAR = 'varchar',
  DATE = 'date',
  TIMESTAMP = 'timestamp',
  FLOAT8 = 'float8',
  NUMERIC = 'numeric',
  INT4 = 'int4',
}
